<template>
    <div class="c-header-panel c-header-manage" id="c-header-manage">
        <span class="u-post u-manage">
            <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="18" height="18" v-bind:class="'u-add'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M224 423.84V231.744l192-.096.096 192.096L224 423.84zm192.096-256.096H223.904A64 64 0 00160 231.68v192.192a64 64 0 0063.904 63.904h192.192A64 64 0 00480 423.84V231.68a64 64 0 00-63.904-63.904zM224 807.84V615.744l192-.096.096 192.096L224 807.84zm192.096-256.096H223.904A64 64 0 00160 615.68v192.192a64 64 0 0063.904 63.904h192.192A64 64 0 00480 807.84V615.68a64 64 0 00-63.904-63.904zm287.968-88.128l-135.84-135.84 135.712-135.84L839.84 327.68 704.064 463.616zm181.024-181.024L749.184 146.688a64 64 0 00-90.368 0L522.912 282.56a63.456 63.456 0 00-18.656 45.056 63.456 63.456 0 0018.656 45.312l135.904 135.936a63.904 63.904 0 0090.368-.032l135.904-135.904a63.936 63.936 0 000-90.368zM608 807.84V615.744l192-.096.096 192.096L608 807.84zm192.096-256.096H607.904A64 64 0 00544 615.68v192.192a64 64 0 0063.904 63.904h192.192A64 64 0 00864 807.84V615.68a64 64 0 00-63.904-63.904z" fill="#fff"/></svg>
        </span>
        <ul class="u-menu u-pop-content">
            <li v-for="item in userPanel" :key="item.label">
                <a :href="item.link" :target="item.target || '_self'" class="u-menu-item">
                    <img :src="resolveImg(item.icon)" svg-inline class="u-menu-icon" :alt="item.icon">
                    {{ item.label }}
                </a>
            </li>
            <hr v-if="userPanel.length" />
            <template v-if="isEditor">
                <li v-for="item in adminPanel" :key="item.label">
                    <a :href="item.link" :target="item.target || '_self'" class="u-menu-item">
                        <img :src="resolveImg(item.icon)" svg-inline class="u-menu-icon" :alt="item.icon">
                        {{ item.label }}
                    </a>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
import User from "@jx3box/jx3box-common/js/user";
import panel from "../../assets/data/panel.json";
import { getMenu } from "../../service/header";
import { __imgPath } from "@jx3box/jx3box-common/data/jx3box.json";
export default {
    name: "Manage",
    data() {
        return {
            panel,
        };
    },
    computed: {
        userPanel: function () {
            return this.panel.filter((item) => {
                return !item.onlyAdmin;
            });
        },
        adminPanel: function () {
            return this.panel.filter((item) => {
                return item.onlyAdmin;
            });
        },
        isEditor() {
            return User.isEditor();
        },
    },
    mounted() {
        this.loadPanel();
    },
    methods: {
        loadPanel: function () {
            try {
                const panel = JSON.parse(sessionStorage.getItem("panel"));
                if (panel) {
                    this.panel = panel;
                } else {
                    getMenu("panel").then((res) => {
                        this.panel = res.data?.data?.val;
                        sessionStorage.setItem("panel", JSON.stringify(this.panel));
                    });
                }
            } catch (e) {
                this.panel = panel;
                console.log("loadPanel error", e);
            }
        },
        resolveImg: function (img) {
            // return __imgPath + "image/header/panel/" + img;
            return 'https://img.jx3box.com/image/box/pvp.svg'
        },
    },
};
</script>

<style lang="less">
// 管理菜单
.c-header-manage {
    height: 100%;

    .u-manage {
        padding: 0 10px 0 8px;
        height: 100%;
        .flex;
        align-items: center;

        svg {
            .size(19px);
        }

    }
    .u-menu {
        .u-menu-item {
            .flex;
            align-items: center;
            gap: 4px;
        }
        .u-menu-icon {
            width: 16px;
            height: 16px;
    }
    }
}
</style>
